import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteTipoDeDocumentoDeGarantia,
  getTiposDeDocumentoDeGarantia,
  patchTipoDeDocumentoDeGarantia,
  postTipoDeDocumentoDeGarantia,
} from 'api/recaudacion/tiposDeDocumentosDeGarantia';

// eslint-disable-next-line react/prop-types
const TiposDeDocumentoDeGarantia = ({ permission }) => (
  <PlainCRUD
    title="tipo de documento de garantía"
    permission={permission}
    get={getTiposDeDocumentoDeGarantia}
    post={postTipoDeDocumentoDeGarantia}
    patch={patchTipoDeDocumentoDeGarantia}
    delete={deleteTipoDeDocumentoDeGarantia}
    withoutState
    fields={[
      defaultFields.descripcion,
    ]}
  />
);

export default TiposDeDocumentoDeGarantia;
